import { TABLET_API_ORIGIN } from '@/global/env';
import { RestClientInterface } from '@/lib/restClient';
import { SiteListResponse } from '@/services/Site/hooks/list/useSiteList';
import { SiteUpdateParams } from '@/services/Site/hooks/update/useSiteUpdate';

interface Interface {
  list: () => Promise<SiteListResponse[]>;
  update: (id: string, params: SiteUpdateParams) => Promise<void>;
}

export class SiteService implements Interface {
  constructor(private readonly restClient: RestClientInterface) {}

  public async list(): Promise<SiteListResponse[]> {
    return await this.restClient.get<SiteListResponse[]>(
      `${TABLET_API_ORIGIN}/dashboard-api/sites` as const
    );
  }

  public async update(id: string, params: SiteUpdateParams): Promise<void> {
    return await this.restClient.patch(
      `${TABLET_API_ORIGIN}/dashboard-api/sites/${id}` as const,
      params
    );
  }
}
